import { createRoleApi, createUserApi } from '@e-learning/core';
import { api } from '../../../../api/client';

const userApi = createUserApi(api);
const roleApi = createRoleApi(api);

/**
 * Hook para gestão de usuários no B2B.
 * Integração com v1/User (pagination, create, update, inactivate) e v1/Role (lista de roles).
 */
export function useUsers() {
  return {
    fetchUsers: userApi.fetchUsers,
    fetchUserGroups: userApi.fetchUserGroups,
    fetchRoles: roleApi.fetchRoles,
    registerUser: userApi.registerUser,
    updateUser: userApi.updateUser,
    inactivateUser: userApi.inactivateUser,
  };
}
